import React, {useState, useMemo, useEffect} from 'react';
import {useTable, useRowSelect} from 'react-table';
import moment from 'moment';
import {X} from 'react-feather';
import {ReactComponent as SearchIcon} from '@images/search.svg';
import {ContentWrapper, Button} from '@components';
import {
  getreedemed,
  getReward,
  Acceptapi,
  getRewardNewApi,
  changeRewardStatus,
  getPurchases,
  ProductPurchaseNew,
  changeGiftStatus,
  showPurchaseStatusChangeSuccessToast,
} from '@apis';
import {useMutation} from 'react-query';
import {ReactComponent as Gift} from '@images/gift.svg';
import {ReactComponent as User} from '@images/user.svg';
import {ReactComponent as Basket} from '@images/basket.svg';
import {ReactComponent as Star} from '@images/star.svg';
import debby from '@images/debby.png';
import {continueStatement} from '@babel/types';
import useStore from '@context/useStore';
import toast from 'react-hot-toast';
import axios from 'axios';
import {languageToAcceptLanguage} from '@constants/languages';
import {useTranslation} from 'react-i18next';
import i18n from '../../i18n';
import {getAbsoluteImageUrl} from '../../utils/imageUtils';

import {API_HOST} from '@apis/';
const auth_token =
  localStorage.getItem('nls:auth') || sessionStorage.getItem('nls:auth');

const IndeterminateCheckbox = React.forwardRef(
  ({indeterminate, ...rest}, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <input type="checkbox" ref={resolvedRef} {...rest} />
      </>
    );
  },
);

const Table = ({columns, data, loading}) => {
  const {t} = useTranslation();
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    state: {selectedRowIds},
  } = useTable({columns, data}, useRowSelect, hooks => {
    hooks.visibleColumns.push(columns => [
      {
        id: 'selection',
        Header: ({getToggleAllRowsSelectedProps}) => (
          <div>
            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
          </div>
        ),
        Cell: ({row}) => (
          <div>
            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
          </div>
        ),
      },
      ...columns,
    ]);
  });

  return (
    <table {...getTableProps()} className="min-w-full">
      <thead className="bg-tableHeaderBg p-4">
        {headerGroups.map(headerGroup => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map(column => (
              <th
                {...column.getHeaderProps()}
                className="text-left text-menu font-normal uppercase text-sm px-4 py-2">
                {column.render('Header')}
              </th>
            ))}
          </tr>
        ))}
      </thead>
      {loading ? (
        <tbody>
          <tr>
            <td colSpan="100%" className="text-center p-5">
              {t('dashboard.loading')}
            </td>
          </tr>
        </tbody>
      ) : (
        <tbody {...getTableBodyProps()}>
          {rows.length > 0 ? (
            rows.map(row => {
              prepareRow(row);
              return (
                <tr {...row.getRowProps()}>
                  {row.cells.map(cell => {
                    return (
                      <td
                        {...cell.getCellProps()}
                        className="p-4 whitespace-nowrap text-sm">
                        {cell.render('Cell')}
                      </td>
                    );
                  })}
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="100%" className="text-center p-5">
                {t('dashboard.noData')}
              </td>
            </tr>
          )}
        </tbody>
      )}
    </table>
  );
};

const Dashboard = () => {
  const {storeDetails} = useStore();
  const {t} = useTranslation();

  const [acceptreward, setacceptrewardData] = useState([]);
  const [rejectreward, setrejectrewarddData] = useState([]);
  const [key, setKey] = useState(0);
  const [loading, setLoading] = useState(false);

  const [refresh, setRefresh] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [stats, setData] = useState([
    {
      id: '1',
      title: t('dashboard.giftsRedeemed'),
      quantity: 0,
      icon: () => <Gift className="fill-current text-white" />,
    },
    {
      id: '2',
      title: t('dashboard.pointsRedeemed'),
      quantity: 0,
      icon: () => <Star className="fill-current text-white" />,
    },

    {
      id: '3',
      title: t('dashboard.newRequests'),
      quantity: 0,
      icon: () => <Basket className="fill-current text-white" />,
    },
  ]);
  const [_rewardData, setrewardData] = useState([]);
  const [rewardData, setRewardData] = useState([]);

  const RewardAccept = useMutation(params => Acceptapi(params));

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchQuery.trim());
    }, 300);
    return () => clearTimeout(timer);
  }, [searchQuery]);

  const fetchRewards = () => {
    const token =
      localStorage.getItem('nls:auth') || sessionStorage.getItem('nls:auth');
    setLoading(true);
    const searchParam = debouncedSearch
      ? `?q=${encodeURIComponent(debouncedSearch)}`
      : '';
    let config = {
      url: API_HOST + `/admin-api/v1/latest-stats${searchParam}`,
      method: 'get',
      headers: {
        Authorization: `Token ${token}`,
        'Content-Type': 'application/json',
        'Accept-Language': languageToAcceptLanguage(i18n.language),
      },
    };
    axios(config)
      .then(res => {
        if (res.data && Array.isArray(res.data) && res.data.length > 0) {
          setRewardData(res.data);
        } else {
          setRewardData([]);
        }
      })
      .catch(error => {
        console.error('Error fetching latest stats:', error);
        setRewardData([]);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchRewards();
    if (!debouncedSearch) {
      fetchDashboardData();
    }
  }, [refresh, debouncedSearch]);

  const fetchDashboardData = async () => {
    try {
      const token =
        localStorage.getItem('nls:auth') || sessionStorage.getItem('nls:auth');

      const response = await fetch(
        `${API_HOST}/admin-api/v1/dashboard/counts`,
        {
          method: 'GET',
          headers: {
            'Accept-Language': languageToAcceptLanguage(i18n.language),
            Authorization: `Token ${token}`,
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const res = await response.json();

      const data = [
        {
          id: '1',
          title: t('dashboard.giftsRedeemed'),
          quantity: Number(res.gift_redeemed_count) || 0,
          icon: () => <Gift className="fill-current text-white" />,
        },
        {
          id: '2',
          title: t('dashboard.pointsRedeemed'),
          quantity: Number(res.total_point_redeemed) || 0,
          icon: () => <Star className="fill-current text-white" />,
        },
        {
          id: '3',
          title: t('dashboard.newRequests'),
          quantity: Number(res.new_request_count) || 0,
          icon: () => <Basket className="fill-current text-white" />,
        },
      ];

      setData(data);
    } catch (error) {
      console.error('Error fetching dashboard data:', error);
      const defaultData = [
        {
          id: '1',
          title: t('dashboard.giftsRedeemed'),
          quantity: 0,
          icon: () => <Gift className="fill-current text-white" />,
        },
        {
          id: '2',
          title: t('dashboard.pointsRedeemed'),
          quantity: 0,
          icon: () => <Star className="fill-current text-white" />,
        },
        {
          id: '3',
          title: t('dashboard.newRequests'),
          quantity: 0,
          icon: () => <Basket className="fill-current text-white" />,
        },
      ];
      setData(defaultData);
    }
  };

  //Accept Reward Data
  const acceptEarn = async id => {
    try {
      if (id.original.data_type === 'reward') {
        const paramdata = {
          status: 'accepted',
        };
        await changeRewardStatus(id.original.id, paramdata);
      } else if (id.original.data_type === 'product') {
        await ProductPurchaseNew(id.original.id, {accepted: true});
        showPurchaseStatusChangeSuccessToast(true);
      } else if (id.original.data_type === 'gift') {
        const paramdata = {
          status: 'accepted',
        };
        await changeGiftStatus(id.original.id, paramdata);
      }

      // Refresh data after action
      setTimeout(() => {
        fetchRewards();
        fetchDashboardData();
      }, 1000);
    } catch (error) {
      console.error('Error accepting data:', error);
      toast.error(
        typeof error === 'string'
          ? error
          : t('approve.errorApprovingItems'),
      );
    }
  };

  //Reject Reward Data
  const rejectEarn = async id => {
    try {
      if (id.original.data_type === 'reward') {
        const paramdata = {
          status: 'rejected',
        };
        await changeRewardStatus(id.original.id, paramdata);
      } else if (id.original.data_type === 'product') {
        await ProductPurchaseNew(id.original.id, {accepted: false});
        showPurchaseStatusChangeSuccessToast(false);
      } else if (id.original.data_type === 'gift') {
        const paramdata = {
          status: 'rejected',
        };
        await changeGiftStatus(id.original.id, paramdata);
      }

      // Refresh data after action
      setTimeout(() => {
        fetchRewards();
        fetchDashboardData();
      }, 1000);
    } catch (error) {
      console.error('Error rejecting data:', error);
      toast.error(
        typeof error === 'string'
          ? error
          : t('approve.errorRejectingItems'),
      );
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: t('dashboard.user'),
        accessor: 'user_detail',
        Cell: ({value}) => (
          <div className="flex items-center">
            <div>
              {value &&
              value.profile &&
              value.profile.profile_image !== null ? (
                <img
                  src={getAbsoluteImageUrl(value.profile.profile_image)}
                  className="user-avatar"
                  alt="User avatar"
                />
              ) : (
                <img
                  src="https://cdn-icons-png.flaticon.com/512/1077/1077063.png"
                  className="user-avatar"
                  alt="User avatar"
                />
              )}
            </div>
            <div className="px-4">
              <p className="text-left">
                {value && value.first_name} {value && value.last_name}
              </p>
            </div>
          </div>
        ),
      },
      {
        Header: t('dashboard.confirmation'),
        accessor: 'code',

        Cell: ({value}) => (
          <p className="text-xs text-left tracking-widest">{value}</p>
        ),
      },
      {
        Header: t('dashboard.points'),
        accessor: 'points_paid',
        Cell: ({row}) => (
          <p className="text-xs text-left tracking-widest">
            {row && row.values && row.values.data_type === 'product'
              ? `- ${row && row.values && row.values.points_paid}`
              : row && row.values && row.values.data_type === 'reward'
              ? `+ ${row && row.values && row.values.level_award.points}`
              : ''}
          </p>
        ),
      },

      {
        Header: t('dashboard.discount'),
        accessor: 'level_award',
        Cell: ({value}) => (
          <p className="text-xs text-left tracking-widest">
            {value && value.discount !== undefined && `${value.discount}%`}
          </p>
        ),
      },
      {
        Header: t('dashboard.receivedFor'),
        accessor: 'data_type',
        Cell: ({value}) => (
          <div className="bg-tableHeaderBg px-2 py-1 rounded">
            <p className="text-btnSecondaryText text-xs text-center">
              {value === 'product'
                ? t('dashboard.productPurchase')
                : value === 'reward'
                ? t('dashboard.rewardClaim')
                : t('dashboard.giftClaim')}
            </p>
          </div>
        ),
      },
      {
        Header: t('dashboard.status'),
        accessor: 'accepted',
        Cell: ({row}) => (
          <div className="inline-flex items-center">
            <>
              <Button
                onClick={() => {
                  acceptEarn(row);
                }}
                label={t('dashboard.accept')}
                type="primary"
              />
              <Button
                onClick={() => {
                  rejectEarn(row);
                }}
                label={t('dashboard.reject')}
                type="secondary"
              />
            </>
          </div>
        ),
      },
    ],
    [t],
  );

  const Acceptslected = async () => {
    setrewardData(acceptreward);
  };
  const Rejectslected = async () => {
    setrewardData(rejectreward);
  };
  const fetchData = async () => {
    const resp = await getreedemed();
    const rewardlst = await getReward();

    stats[0]['quantity'] = resp.gifts_redeemed;
    stats[1]['quantity'] = resp.points_redeemed;
    setData(stats);
    var acceptreward_1 = [];
    var rejectreward_1 = [];
    if (rewardlst?.results.length > 0) {
      for (var i = 0; i < rewardlst.results.length; i++) {
        rewardlst.results[i].user.rewardid = rewardlst.results[i].id;
        if (rewardlst.results[i].accepted == false) {
          rejectreward_1.push(rewardlst.results[i]);
        } else if (rewardlst.results[i].accepted == true) {
          acceptreward_1.push(rewardlst.results[i]);
        }
      }
    }
    setacceptrewardData(acceptreward_1);
    setrejectrewarddData(rejectreward_1);
    //    setrewardData([]);
    setrewardData(rewardlst?.results);
    setKey(Math.random());
  };

  return (
    <ContentWrapper
      hasSearch={false}
      breadcrumb={[{title: t('sidebar.menuItems.home'), link: '/'}]}>
      <div className="flex flex-wrap" key={key}>
        {stats.map(stat => (
          <div
            key={stat.id}
            className="flex-1 bg-red rounded-md shadow-stats mr-8 last:mr-0 mb-4 p-4 pl-6 min-h-full">
            <div className="flex flex-row items-center">
              {stat.icon()}
              <p className="text-white ml-4 font-semibold">{stat.quantity}</p>
            </div>
            <p className="text-white pt-3 uppercase font-semibold">
              {stat.title}
            </p>
          </div>
        ))}
      </div>
      <div className="flex flex-col w-full mt-6">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px',
            gap: '16px',
            flexWrap: 'wrap',
          }}>
          <h5 className="mb-0">{t('dashboard.newRequests')}</h5>
          <div
            className="relative"
            style={{minWidth: '240px', maxWidth: '320px', flex: '1'}}>
            <input
              type="text"
              value={searchQuery}
              onChange={e => setSearchQuery(e.target.value)}
              placeholder={t('approve.searchCustomer')}
              className={`border border-gray-200 focus:outline-none focus:border-indigo-700 rounded w-full text-sm text-gray-700 bg-gray-100 pl-10 py-2 ${
                searchQuery ? 'pr-9' : 'pr-3'
              }`}
            />
            <div className="text-gray-500 absolute left-3 top-0 bottom-0 flex items-center pointer-events-none">
              <SearchIcon height={16} />
            </div>
            {searchQuery ? (
              <button
                type="button"
                onClick={() => setSearchQuery('')}
                className="absolute right-2 top-0 bottom-0 flex items-center text-gray-500 hover:text-gray-700"
                aria-label={t('approve.clearSearch')}>
                <X size={16} />
              </button>
            ) : null}
          </div>
        </div>
        <Table columns={columns} data={rewardData} loading={loading} />
      </div>
    </ContentWrapper>
  );
};

export default Dashboard;
